exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "span._2w74x{cursor:pointer}span._1wjK1,span._2w74x{font-size:16px;margin:0 8px}._868ai{color:#777;font-style:italic}._1oOHP{background:#8b0000;color:#fff;font-weight:700}._1oOHP a{color:#fff!important;text-decoration:underline!important}._3_iYe{background:#f3d8d8;color:#8b0000}._1FF9g{background:#f9fad2}._17esX{background:#d2e7fa}.xJILn{padding:0!important}._2mKjK{padding:7px;line-height:24px}._1rszJ{padding:7px 3px;line-height:30px}._21kLo div{overflow-x:hidden!important}._21kLo div div div div{overflow:hidden!important}", ""]);

// exports
exports.locals = {
	"btn": "_2w74x",
	"info": "_1wjK1",
	"sinSnapshot": "_868ai",
	"incumplimiento": "_1oOHP",
	"facturaCancelada": "_3_iYe",
	"conCambios": "_1FF9g",
	"conActualizaciones": "_17esX",
	"tdClear": "xJILn",
	"field": "_2mKjK",
	"fieldAsignacion": "_1rszJ",
	"hidden": "_21kLo"
};